module.exports = __webpack_public_path__ + "img/deactivate_user.cd22c4a3.svg";